<template>
  <div>
    <div class="row">
      <div class="col-lg-2">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <th>Tags</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="tag in f.linkTags" :key="tag">
            <td>{{ tag }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-lg-4">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <th colspan="2">Untagged Domains ({{ untaggedDomains.length }})</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="domain in untaggedDomains" :key="domain.domain">
            <td>{{ domain.domain }}</td>
            <td>
              <v-select multiple taggable push-tags :options="f.linkTags" @input="updateDomain($event, domain.domain)" >
              </v-select>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-lg-4">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <th colspan="2">Tagged Domains ({{ taggedDomains.length }})</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="domain in taggedDomains" :key="domain.domain">
            <td>{{ domain.domain }}</td>
            <td>
              <v-select multiple taggable push-tags :options="f.linkTags" :value="domain.tags" @input="updateDomain($event, domain.domain)" >
              </v-select>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
  data () {
    return {
      tagName: '',
      untaggedDomains: [],
      taggedDomains: []
    }
  },
  mounted () {
    document.title = 'Link Tags :: PBN360 by Aphex Media'
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
    this.loadUntagged()
    this.loadTagged()
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  methods: {
    loadUntagged () {
      axios.get('/pbn/content/links/untagged')
        .then(r => {
          this.untaggedDomains = r.data.data
        })
        .catch(e => {
          this.$toastr.error(e)
        })
    },
    loadTagged () {
      axios.get('/pbn/content/links/tagged')
        .then(r => {
          this.taggedDomains = r.data.data
        }).catch(e => {
          this.$toastr.error(e)
        })
    },
    updateDomain (tags, domain) {
      axios.put('/pbn/content/links/tag-domain/' + domain, {
        domain: domain,
        tags: tags
      }).then(r => {}).catch(e => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Overview/LinkTags.vue